// extracted by mini-css-extract-plugin
export default {"UpdateLocation":"UpdateLocation_UpdateLocation__bkctp","form":"UpdateLocation_form__3Q1rr"};